import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    TreeViewGroupGuideConstantType,
    TreeViewGroupDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import {
    getTreeViewRowIndent
} from "../row/stylesheet";

export const getTreeViewGroupGuide = ({
    isActive,
    measures,
    borders,
    colors,
    level
}: TreeViewGroupGuideConstantType): ViewStyle => {
    return {
        backgroundColor: isActive ? colors.content.border.hover : colors.content.border.subtle,
        start: getTreeViewRowIndent({
            measures,
            level
        }) + (measures.slotWidth - borders.separator) / 2,
        width: borders.separator,
        top: measures.rowGap
    };
};

const stylesheet = StyleSheet.create({
    container: {
        flexDirection: "column",
        position: "relative",
        minWidth: 0
    },
    guide: {
        pointerEvents: "none",
        position: "absolute",
        bottom: 0
    }
});

export const useStyles = ({
    measures
}: TreeViewGroupDynamicStyleType) => {
    const styles = {
        container: {
            paddingTop: measures.rowGap,
            gap: measures.rowGap
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
